module.exports = __webpack_public_path__ + "static/img/数字人系统定制.be92904c.png";